import { Button } from '@/ui-kit';
import styles from './premium-banner.module.scss';
import { BadgePremium } from '../badge-premium';
import { routesApp } from '@/constans/routes';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { useTranslation } from 'react-i18next';

export const PremiumBanner: React.FC = () => {
    const { t } = useTranslation()

    const { isVibrationEnabled } = useVibration(state => state)

    const onActivatePremiumClick = () => {
        if (isVibrationEnabled) {
            WebApp.HapticFeedback.impactOccurred('medium')
            // pass for not android
            navigator.vibrate?.(10)
        }
    }

    return (
        <BadgePremium
            title={t('profile.find_out_who_likes_you')}
            description={t('profile.pay_like_access_secondary')}
            type="column">
            <Button
                className={styles.buttonBadge}
                to={routesApp.subscription}
                typeColor="orange"
                isLink
                onClick={onActivatePremiumClick}>
                {t('activate_premium')}
            </Button>
        </BadgePremium>
    )
}
